/**
*
* ToolIcon
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import IconHolder from 'components/Icons/IconHolder';

import ToolIconWrapper from './styles/ToolIconWrapper';
import ToolIconHolder from './styles/ToolIconHolder';
import ToolIconHolderTitle from './styles/ToolIconHolderTitle';

class ToolIcon extends React.PureComponent {

  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {

    const {
      attr,
    } = this.props;


    if (this.props.onClick) {
      event.stopPropagation();
      this.props.onClick(attr);
    }
  }

  render() {

    const {
      className,
      title,
      thisStyles,
      icon,
      thisStylesHover
    } = this.props;

    const titleContent = title ? (
      <ToolIconHolderTitle thisStyles={thisStyles ? thisStyles : {}}>
        {title}
      </ToolIconHolderTitle>
    ) : '';


    return (
      <ToolIconWrapper
        className={className}
        thisStyles={thisStyles ? thisStyles : {}}
        onClick={this.handleClick}
        thisStylesHover={thisStylesHover}
      >
        {icon ? (<ToolIconHolder thisStyles={thisStyles ? thisStyles : {}}>
          <IconHolder icon={icon} thisStyles={thisStyles}/>
        </ToolIconHolder>) : ''}
        {titleContent}
      </ToolIconWrapper>
    );
  }
}

ToolIcon.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  attr: PropTypes.string,
  className: PropTypes.string,
  thisStyles: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
};

export default ToolIcon;
